import round from 'lodash/round';
const parseUtils = {
    parseBool(value) {
        if (typeof value === 'string') {
            value = value.toLowerCase();
        }
        switch (value) {
            case true:
            case 'true':
            case 1:
            case '1':
            case 'on':
            case 'yes':
                return true;
            default:
                return false;
        }
    },
    parseSize(value) {
        if (typeof value === 'number') {
            return round(value);
        }
        return 0;
    },
};
export default parseUtils;
